<template>
  <div class="youkexianshangxingweifenxi">
    <ul>
      <li>
        <div class="circle">
          <div class="circle-out"></div>
          <div class="circle-in"></div>
          App排行
        </div>
      </li>
      <li>
        <div class="circle">
          <div class="circle-out"></div>
          <div class="circle-in"></div>
          行为曲线
        </div>
      </li>
      <li>
        <div class="circle">
          <div class="circle-out"></div>
          <div class="circle-in"></div>
          搜索偏好
        </div>
      </li>
      <li>
        <div class="circle">
          <div class="circle-out"></div>
          <div class="circle-in"></div>
          旅游细分
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "YoukeXianshangXingweiFenxi",
  props: {},
  data() {
    return {};
  },
  mounted() {}
};
</script>

<style scoped lang="less">
.youkexianshangxingweifenxi {
  margin-top: 0.1rem;
  ul {
    overflow: hidden;
    li {
      float: left;
      width: 25%;
      position: relative;
      .circle {
        width: 1.06rem;
        height: 1.06rem;
        line-height: 1.06rem;
        font-size: 0.2rem;
      }
      .circle-out {
        width: 1.06rem;
        height: 1.06rem;
        background: url(../../assets/youkexianshangxingweifenxi/circle-out.png);
        background-size: 100% 100%;
        position: absolute;
        left: 0;
        top: 0;
        animation: zhengzhuan 3s linear infinite;
      }
      .circle-in {
        width: 1.06rem;
        height: 1.06rem;
        background: url(../../assets/youkexianshangxingweifenxi/circle-in.png);
        background-size: 100% 100%;
        position: absolute;
        left: 0;
        top: 0;
        animation: fanzhuan 2s linear infinite;
      }
    }
    li:nth-child(even) {
      margin-top: 0.86rem;
    }
  }
}
@keyframes zhengzhuan {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@keyframes fanzhuan {
  0% {
    transform: rotate(360deg);
  }
  100% {
    transform: rotate(0deg);
  }
}
</style>
